import React, { useEffect, useState } from 'react'
import AppSidebar from '../../../components/AppSidebar'
import AppHeader from '../../../components/AppHeader'
import PageHeader from '../../../components/PageHeader'
import { toast, ToastContainer } from 'react-toastify'
import CustomerService from '../../../services/CustomersService'
import { useForm, Controller } from 'react-hook-form';
import EmployeeService from '../../../services/EmployeeService';
import FeedbackLinkService from '../../../services/FeedbackLinkService';
import { IoMdAdd } from "react-icons/io";
import CreateUpdateProductModal from '../../customers/components/modals/CreateUpdateProductModal';
import ProductService from '../../../services/ProductService';
import EmployeeFormModal from '../../customers/components/modals/EmployeeFormModal'

const CreateFeedbackLink = () => {
    const { control, handleSubmit, formState: { errors }, reset, register } = useForm();
    const [customerOptions, setCustomerOptions] = useState([]);
    const [link, setLink] = useState(null);
    const [productOptions, setProductOptions] = useState([]);
    const [customer, setCustomer] = useState({});
    const base_url = process.env.REACT_APP_BASE_URL
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [productId, setProductId] = useState('');
    const [productList, setProductList] = useState([]);
    const [editingProduct, setEditingProduct] = useState(null);
    const [showProductModal, setShowProductModal] = useState(false);
    const [showEmployeeFormModal, setShowEmployeeFormModal] = useState(false);
    const productForm = useForm();
    const [customerId, setCustomerId] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState({});
    const [submitType, setSubmitType] = useState('create');
    const [isLoading, setIsLoading] = useState(false);

    const fetchCustomerList = async () => {
        try {
            const response = await CustomerService.listAll();
            if (response.status === 200) {
                const options = response.data.data.map(category => ({
                    value: category.id,
                    label: category.company
                }));
                setCustomerOptions(options);
            }
        } catch (error) {
            toast.error(error?.message || "An error occurred");
        }
    }

    const fetchProductList = async () => {
        try {
            const response = await ProductService.list();
            if (response.status === 200) {
                setProductList(response.data?.data || []);
            }
        } catch (error) {
            console.error(error);
            toast.error(error?.message || 'Failed to fetch product list.');
        }
    };
    useEffect(() => {
        fetchCustomerList();
        fetchProductList();
    }, [])

    const fetchCustomerProducts = async (id) => {
        try {
            const response = await CustomerService.customerProductList(id);
            if (response.status === 200) {
                const productList = response?.data?.data;
                if (productList.length > 0) {
                    const options = productList?.map(product => ({
                        value: product?.id,
                        label: product?.name
                    }))
                    setProductOptions(options);
                    const customerData = {
                        id: customer.id,
                        company: customer.company
                    }
                    setCustomer(customerData);
                } else {
                    toast.error("No products found for this customer");
                }
            }
        } catch (error) {
            toast.error(error?.message || "An error occurred");
        }
    }
    const handleSelectChange = (customerId) => {
        setCustomer(customerOptions.find(option => option.value === customerId) || {});
        setLink(null);
        fetchCustomerProducts(customerId);
        employeeList(customerId);
        const customer = customerOptions.find(option => option.value === Number(customerId));
        setSelectedCustomer(customer);
        setCustomerId(customerId)
    }
    const handleEmployeeChange = (employeeId) => {
        const data = {
            customer_id: customer.id,
            employee_id: employeeId,
            product_id: productId,
            timestamp: new Date().getTime()
        }
        const encryptedData = btoa(JSON.stringify(data));
        const shortUrl = `${base_url}/feedbacks/create?data=${encryptedData}`
        setLink(shortUrl);
    }
    const employeeList = async (customerId) => {
        try {
            const response = await EmployeeService.list(customerId);
            if (response.status === 200) {
                const options = response.data.data.map(employee => ({
                    value: employee.id,
                    label: employee.name
                }));
                setEmployeeOptions(options);
            } else {
                toast.error("No employees found for this customer");
            }
        } catch (error) {
            toast.error(error?.message || "An error occurred");
        }
    }
    const handleProductChange = (productId) => {
        setProductId(productId);
    }
    const onFeedbackSubmit = async (data) => {
        setIsLoading(true); // <- Moved here to ensure it's only set when form submits
        try {
            data.type = 'product_feedback';
            data.link = link;
            data.send_email = submitType === 'create' ? false : true;

            const response = await FeedbackLinkService.create({ data });

            if (response.status === 201) {
                toast.success(response?.data?.message);
                reset();
                setLink(null);
            }
        } catch (error) {
            toast.error(error?.message || "An error occurred");
        } finally {
            setIsLoading(false); // <- Always stop loading here
        }
    };

    const onProductSubmit = async (data) => {
        try {
            data.customer_id = parseInt(customerId);
            const response = await CustomerService.createProducts({ data });
            if (response.status === 201) {
                setShowProductModal(false);
                toast.success(response?.data?.message);
            }
        } catch (error) {
            toast.error(error?.message || "An error occurred");
        }
    }

    const openProductCreateModal = () => {
        setEditingProduct(null);
        setShowProductModal(true);
    };

    const closeProductModal = () => {
        setShowProductModal(false);
    };

    const openEmployeeFormModal = () => {
        setShowEmployeeFormModal(true);
    };

    const closeEmployeeFormModal = () => {
        setShowEmployeeFormModal(false);
    };

    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader />
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <PageHeader title="Create Feedback Link" button_label1="Back" link_to1="/feedback-links" className1="btn btn-primary btn-sm me-2" />
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="TabPane"
                                    role="tabpanel"
                                    aria-labelledby="TabTab"
                                >
                                    <div className="card">
                                        <div className="card-body">
                                            <form onSubmit={handleSubmit(onFeedbackSubmit)}>
                                                <div className="row g-3">
                                                    <div className="col-md-6">
                                                        <label className="form-label">Customers</label>
                                                        <Controller
                                                            name="customer_id"
                                                            control={control}
                                                            rules={{ required: 'Customer is required.' }}
                                                            render={({ field }) => (
                                                                <select
                                                                    {...field}
                                                                    className="form-select"
                                                                    value={field.value || ""}
                                                                    onChange={(e) => {
                                                                        field.onChange(e.target.value);
                                                                        handleSelectChange(e.target.value);
                                                                    }}
                                                                >
                                                                    <option value="" disabled>Select a customer</option>
                                                                    {customerOptions.map((option, index) => (
                                                                        <option key={`${option.value}-${index}`} value={option.value}>
                                                                            {option.label}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            )}
                                                        />
                                                        {errors.customer_id && <p className="text-danger">{errors.customer_id.message}</p>}
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="form-label">Products</label>
                                                        <Controller
                                                            name="product_id"
                                                            control={control}
                                                            rules={{ required: 'Product is required.' }}
                                                            render={({ field }) => (
                                                                <div className="input-group mb-3">
                                                                    <select
                                                                        {...field}
                                                                        className="form-select"
                                                                        value={field.value || ""}
                                                                        onChange={(e) => {
                                                                            field.onChange(e.target.value);
                                                                            handleProductChange(e.target.value);
                                                                        }}
                                                                        disabled={productOptions.length === 0}
                                                                    >
                                                                        <option value="" disabled>Select a product</option>
                                                                        {productOptions.map((option, index) => (
                                                                            <option key={`${option.value}-${index}`} value={option.value}>
                                                                                {option.label}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                    <button
                                                                        className="btn btn-outline-secondary"
                                                                        type="button"
                                                                        onClick={openProductCreateModal}
                                                                        disabled={productOptions.length === 0}
                                                                    >
                                                                        <IoMdAdd />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.product_id && <p className="text-danger">{errors.product_id.message}</p>}
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <label className="form-label fw-bold">Employees</label>
                                                    <div className="input-group shadow-sm">
                                                        <Controller
                                                            name="employee_id"
                                                            rules={{ required: 'Employee is required.' }}
                                                            control={control}
                                                            render={({ field }) => (
                                                                <div className="input-group">
                                                                    <select
                                                                        {...field}
                                                                        className="form-select"
                                                                        value={field.value || ""}
                                                                        onChange={(e) => {
                                                                            field.onChange(e.target.value);
                                                                            handleEmployeeChange(e.target.value);
                                                                        }}
                                                                        disabled={employeeOptions.length === 0}
                                                                    >
                                                                        <option value="" disabled>Select an Employee</option>
                                                                        {employeeOptions.map((option, index) => (
                                                                            <option key={`${option.value}-${index}`} value={option.value}>
                                                                                {option.label}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                    <button
                                                                        className="btn btn-outline-secondary"
                                                                        type="button"
                                                                        onClick={openEmployeeFormModal}
                                                                        disabled={employeeOptions.length === 0}
                                                                    >
                                                                        <IoMdAdd />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.employee_id && <p className="text-danger">{errors.employee_id.message}</p>}
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <div className="col-12">
                                                        <label className="form-label fw-bold">Short Link</label>
                                                        <div className="input-group shadow-sm">
                                                            <input
                                                                type="text"
                                                                name="link"
                                                                {...register("link")}
                                                                className="form-control rounded-start"
                                                                placeholder="Short Link"
                                                                value={link || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                        <div className="text-end mt-5">
                                                            <button type="submit" className="btn btn-primary  btn-sm" onClick={() => setSubmitType("create")}>
                                                                Create
                                                            </button>
                                                            <button type="submit" className="btn btn-primary ms-2 btn-sm" onClick={() => {
                                                                setSubmitType("send_email");
                                                            }}
                                                                disabled={isLoading}
                                                            >
                                                                {isLoading ? "Sending..." : "Create & Send Email"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CreateUpdateProductModal
                show={showProductModal}
                handleClose={closeProductModal}
                onSubmit={onProductSubmit}
                handleSubmit={productForm.handleSubmit}
                control={productForm.control}
                errors={productForm.formState.errors}
                register={productForm.register}
                reset={productForm.reset}
                productList={productList}
                initialValues={editingProduct}
            />
            <EmployeeFormModal
                show={showEmployeeFormModal}
                handleClose={closeEmployeeFormModal}
                customer={selectedCustomer}
                refreshEmployeeList={() => employeeList(customerId)}
            />
            <ToastContainer containerId={"toast-container"} />
        </>
    )
}

export default CreateFeedbackLink